import axiosInstance from "../../utils/axiosConfig";
import React, { useState } from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { BiErrorCircle } from "react-icons/bi";
import { TailSpin } from "react-loader-spinner";
import { API_URL } from "../../constant";

const ReactivateUser = ({
  setOpenReactivateModal,
  customerId,
  userFn,
  userLn,
  onSuccess,
}: {
  setOpenReactivateModal: React.Dispatch<React.SetStateAction<boolean>>;
  customerId: string;
  userFn: string;
  userLn: string;
  onSuccess?: () => void;
}) => {
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<string>("");

  const handleSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault();

    if (!loading) {
      setLoading(true);
      axiosInstance
        .patch(`${API_URL}api/users/${customerId}/update-account-status`, {
          status: "ACTIVE",
        })
        .then((r: any) => {
          setLoading(false);

          setSuccess("User reactivated successfully");
          onSuccess?.();
          setTimeout(() => {
            setSuccess("");
            setOpenReactivateModal((prev: any) => !prev);
          }, 3000);
        })
        .catch((e: any) => {
          setError(e.response.data.message);
          setLoading(false);
          setTimeout(() => {
            setError("");
          }, 3000);
          console.log(e.response.data.message);
        });
    }
  };
  return (
    <div className="fixed inset-0 flex font-manrope justify-center items-start overflow-auto pt-16 pb-16  bg-black bg-opacity-80 pr-10 backdrop-blur-sm">
      <div
        className={
          error
            ? " w-11/12 lgss:w-1/3 transition-all p-6 ease-in duration-1000  rounded-xl bg-[#1F1F1F] h-[full]"
            : "w-11/12 lgss:w-1/3 transition-all p-6 ease-in duration-1000  rounded-xl bg-[#1F1F1F] h-[full]"
        }
      >
        <div className="flex   justify-between items-center">
          <h4 className="font-bold text-[20px] font-sora text-white">
            Reactivate User
          </h4>
          <h4
            onClick={() => setOpenReactivateModal((prev: any) => !prev)}
            className="text-[#78C2F7] text-[14px] font-medium cursor-pointer"
          >
            Close
          </h4>
        </div>

        <div className="w-full mt-8">
          {success && (
            <div className="bg-green-600 w-full text-white  text-[16px] rounded-xl justify-start items-center gap-4 flex h-[60px] px-2 font-bold mt-4 mb-4">
              <AiOutlineCheckCircle className="text-3xl text-white" />
              {success}
            </div>
          )}

          <h4 className=" text-center text-[#A0A9AD] text-[15px]">
            Are you sure you want to reactivate {userFn} {userLn}’s account?
          </h4>

          {error && (
            <div className="bg-red-600 text-white  text-[12px] rounded-xl justify-start items-center gap-2 flex h-[50px] px-2 font-bold mt-4">
              <BiErrorCircle className="text-xl" />
              {error}
            </div>
          )}
          <div className="w-full flex justify-center gap-4 items-center mt-8">
            <button
              onClick={handleSubmit}
              className="w-1/2 h-[46px] flex text-[13px] justify-center items-center font-manrope font-medium rounded-xl text-[white] bg-secondary_button "
            >
              {loading ? (
                <TailSpin color="#FFFFFF" height={30} width={30} />
              ) : (
                "Confirm"
              )}
            </button>
            <button
              onClick={() => setOpenReactivateModal((prev: any) => !prev)}
              className="w-1/2 h-[46px] text-[13px] flex justify-center items-center font-manrope font-medium rounded-xl text-secondary_button bg-transparent border border-secondary_button"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReactivateUser;
